import React from 'react';
import { formatOpened, openedKey } from '../../extensions/bundled/task-manager/boardsOverview';
import { boardBackground } from '../../extensions/bundled/task-manager/boardColorValue';
import { isNeutralBoardColor } from './boardColor';
import './BoardsOverview.css';

/**
 * "RECENT · Opened in the last 7 days" (card 7.3): up to four compact rows
 * for boards opened on this device in the last week, each led by a 10 px dot
 * in the board's colour (minimal tiles, 13.10.2026). The caller passes what
 * recentBoards() picked, which is empty below two boards — then this renders
 * nothing.
 */
export default function BoardsRecentStrip({ boards, lastOpened, now, onOpen }) {
  if (!boards || boards.length === 0) return null;
  return (
    <section className="boards-section" aria-label="Recent boards">
      <div className="boards-section-head">
        <span className="boards-section-title">Recent</span>
        <span className="boards-section-note">Opened in the last 7 days</span>
      </div>
      <div className="boards-recent-grid">
        {boards.map((b) => (
          <button
            key={`${b.scopeKey || 'personal'}:${b.id}`}
            type="button"
            className="boards-recent"
            onClick={() => onOpen(b)}
          >
            <span className={`boards-recent-dot${isNeutralBoardColor(b.color) ? ' board-color-dot--neutral' : ''}`} style={{ background: boardBackground(b.color) }} aria-hidden />
            <span className="boards-recent-text">
              <span className="boards-recent-name">{b.name}</span>
              <span className="boards-recent-meta">
                {formatOpened(lastOpened?.[openedKey(b)], now)} · {b.doneCount || 0}/{b.taskCount || 0} done
              </span>
            </span>
          </button>
        ))}
      </div>
    </section>
  );
}
